import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { UsersService } from "./users.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { AppService } from "../app.service";
var UsersComponent = (function () {
    function UsersComponent(usersService, differs, toastr, vcr, router, appService) {
        this.usersService = usersService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.appService = appService;
        this.user = {};
        this.modal = {};
        this.currentUser = {};
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    UsersComponent.prototype.ngOnInit = function () {
        this.title = "Users";
        this.filterParams = {
            size: 10,
            page: 0
        };
        this.currentUser = this.appService.getCurrentUser();
    };
    UsersComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getUsersList();
        }
    };
    UsersComponent.prototype.getUsersList = function () {
        var _this = this;
        this.isLoading = true;
        this.usersService.getUsersList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.usersList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    UsersComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    UsersComponent.prototype.initModal = function (state, user) {
        if (user === void 0) { user = {}; }
        switch (state) {
            case 'create':
                {
                    this.modal = {
                        title: 'Create User',
                        btnName: 'Create',
                        state: state
                    };
                    this.user = {};
                }
                break;
            case 'edit':
                {
                    this.modal = {
                        title: 'Edit User',
                        btnName: 'Save',
                        state: state
                    };
                    this.user = {
                        "id": user.adminId,
                        "active": user.active,
                        "email": user.email,
                        "password": "",
                        "role": user.role
                    };
                }
                break;
        }
        $('#myModal').modal('show');
    };
    UsersComponent.prototype.onSubmit = function (formUser) {
        var _this = this;
        this.isLoading = true;
        switch (this.modal.state) {
            case 'create':
                {
                    this.usersService.createUser(formUser.value)
                        .then(function (res) {
                        if (res.status === 1) {
                            _this.toastr.success(res.message, 'Success!');
                            _this.getUsersList();
                            $('#myModal').modal('hide');
                        }
                        else {
                            _this.toastr.error(res.message, 'Error!');
                            if (res.errorCode === 3000) {
                                localStorage.setItem("alert", JSON.stringify(res.message));
                                _this.router.navigate(['login']);
                            }
                        }
                        _this.isLoading = false;
                    })
                        .catch(function (err) { return console.log(err); });
                }
                break;
            case 'edit':
                {
                    this.usersService.editUser(formUser.value)
                        .then(function (res) {
                        if (res.status === 1) {
                            _this.toastr.success(res.message, 'Success!');
                            _this.getUsersList();
                            $('#myModal').modal('hide');
                        }
                        else {
                            _this.toastr.error(res.message, 'Error!');
                            if (res.errorCode === 3000) {
                                localStorage.setItem("alert", JSON.stringify(res.message));
                                _this.router.navigate(['login']);
                            }
                        }
                        _this.isLoading = false;
                    })
                        .catch(function (err) { return console.log(err); });
                }
                break;
        }
    };
    UsersComponent.prototype.deleteUser = function (user) {
        var _this = this;
        if (confirm("Delete " + user.email + ' ?')) {
            this.isLoading = true;
            this.usersService.deleteUser(user.adminId)
                .then(function (res) {
                if (res.status === 1) {
                    _this.toastr.success(res.message, 'Success!');
                    _this.getUsersList();
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
                _this.isLoading = false;
            })
                .catch(function (err) { return console.log(err); });
        }
    };
    UsersComponent.prototype.activeUser = function (user, ckb) {
        var _this = this;
        this.user = {
            "id": user.adminId,
            "active": ckb.checked,
            "email": user.email,
            "password": "",
            "role": user.role
        };
        this.usersService.editUser(this.user)
            .then(function (res) {
            if (res.status === 1) {
                _this.toastr.success(res.message, 'Success!');
            }
            else {
                ckb.checked = !ckb.checked;
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    return UsersComponent;
}());
export { UsersComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/users/users.component.ts.pre-build-optimizer.js